import React from "react";
import LandingHeader from "../../Components/LandingComponents/landingHeader";
import LandingHero from "../../Components/LandingComponents/landingHero"; 
import '../Landing Page/LandingPage.css'
import LandingStats from "../../Components/LandingComponents/landingStats";
import LandingMessaging from "../../Components/LandingComponents/landingMessaging";
import LandingExpress from "../../Components/LandingComponents/landingExpress";
import LandingMoments from "../../Components/LandingComponents/landingMoments";
import LandingMarket from "../../Components/LandingComponents/landingMarket";
import LandingProfile from "../../Components/LandingComponents/landingProfile";
import LandingHands from "../../Components/LandingComponents/landingHands";
import LandingBuilding from "../../Components/LandingComponents/landingBuilding";
import LandingFooter from "../../Components/LandingComponents/landingFooter";
import LandingPartners from "../../Components/LandingComponents/LandingPartners";
const LandingPage = () => {
  return (
    <div style={{overflow:"hidden"}}>
        <LandingHeader />
        <LandingHero />
        <LandingStats />
        <LandingPartners/>
        <LandingMessaging />
        <LandingExpress />
        <LandingMoments />
        <LandingMarket />
        <LandingProfile />
        <LandingHands />
        <LandingBuilding />
        <LandingFooter />
     
    </div>
  );
};

export default LandingPage;
